module.exports = __webpack_public_path__ + "static/media/no-records.a55409df.svg";